'use strict';

module.exports = require('./Autosuggest').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-autosuggest/dist/index.js
// module id = 208
// module chunks = 0 1